import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/app.component.ts